import StoreLocale from '../../Common/StoreLocale/StoreLocale.APP_ENV.ajs?preParser=processStoreLocale';

export const getStoreLanguages = (storeCode) => StoreLocale.data[storeCode];



// WEBPACK FOOTER //
// ./src/Common/Providers/StoreLanguagesApi.js